import React from "react";
import { gql } from "apollo-boost";
import TransactionsTable from "./TransactionsTable";
import { track } from "../../../utils/analytics";

function Transactions({ data: { transactions = [] } = {} }) {
  track("DASHBOARD_TRANSACTIONS_PAGE_LOADED");

  return (
    <div className="flex mx-auto self-center">
      <div className="flex flex-col flex-1">
        <h1 className="font-title mb-2 text-2xl">Your Activity</h1>
        <TransactionsTable
          initialTransactions={transactions}
          transactionQuery={TRANSACTIONS_QUERY}
          activityQuery={ACTIVITY_QUERY}
        />
      </div>
    </div>
  );
}

const TRANSACTIONS_QUERY = gql`
  query Transactions(
    $searchStr: String
    $fromDate: String
    $toDate: String
    $page: Int = 0
    $perPage: Int = 20
  ) {
    transactions(
      searchStr: $searchStr
      fromDate: $fromDate
      toDate: $toDate
      page: $page
      perPage: $perPage
    ) {
      created_at
      updated_at
      settled_at
      description
      to_name
      category
      amount
      status
      id
    }
    dispute_reasons {
      reason
      description
    }
  }
`;

const ACTIVITY_QUERY = gql`
  query Activity(
    $searchStr: String
    $fromDate: String
    $toDate: String
    $page: Int = 0
    $perPage: Int = 20
  ) {
    activity(
      searchStr: $searchStr
      fromDate: $fromDate
      toDate: $toDate
      page: $page
      perPage: $perPage
    ) {
      created_at
      updated_at
      settled_at
      returned_at
      description
      category
      amount
      status
      id
      type
      disputed
      dispute_status
      dispute_resolved
    }
  }
`;

export default Transactions;
